import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../AuthContext';
import '../dashboard.css';
import UserStatus from './UserStatus';
import API from '../api';


function Payment_History() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, login, logout } = useAuth();
  const [packageId, setPackageId] = useState([]);
  const [subscription, setSubscription] = useState(null);
  const [expiry_date, setExpiryDate] = useState('');
  const [start_date, setStartDate] = useState('');
  const userId = user?.id;
const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 769);
  
useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 769) {
        setSidebarOpen(true);  // open sidebar on desktop
      } else {
        setSidebarOpen(false); // closed on mobile
      }
    };

    handleResize(); // run on mount

    // Optional: listen for window resize to update sidebar automatically
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };
  
  const formatDate = (datetime) => {
  const date = new Date(datetime);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });
  };

  useEffect(() => {
    document.title = "Payment History | TradeBarta.com";
  }, []);
  
  useEffect(() => {
      fetchPaymentHistory();
      fetchSubscription();

  }, [userId]);

const fetchPaymentHistory = async () => {
  try {
    if (!user) return;

    const res = await API.get('/api/payment_history', {
      params: { user_id: user.id }
    });

    console.log('Payment History API Response:', res.data);

    const historyData = res.data?.payhistory;

    if (Array.isArray(historyData)) {
      setHistory(historyData);
    } else {
      console.warn('Unexpected response format:', res.data);
      setHistory([]);
    }

  } catch (err) {
    console.error('Failed to load payment history:', err);
    setHistory([]);
  } finally {
    setLoading(false);
  }
};


  const fetchSubscription = async () => {
    try
    { 
      if (user)
      {
      const res = await API.get('/packageid', { params: { user_id: user?.id } });
      const plan = res.data.package_id;
      setSubscription(plan === 1 ? 'Free  Trial' : plan === 2 ? 'Silver' : plan === 3 ? 'Gold' : 'Platinum');
      setStartDate(formatDate(res.data.start_date) || '');   
      setExpiryDate(formatDate(res.data.expiry_date) || '');
    }} catch (err) {
      console.error('Subscription load failed', err);
    }
  };


  return (
    <div className='dashboard-wrapper'>
          {/* Top Navigation Bar */}
      <header className="header-container">
  <a href="/" className="logo">
    <img src={require("../images/logo.png")} alt="Logo" />
  </a>

                     
                    <button className="menu-toggle" onClick={toggleSidebar}>☰</button>  
     <UserStatus />
          </header>       
      {/* Sidebar and Main Content */}
                    
   <div className={`dashboard-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
  
     <aside className={`sidebar ${sidebarOpen ? 'show-sidebar' : ''}`}>

              <ul>
                <li><a href="/dashboard">Dashboard</a></li>
                <li><a href="/payment_history">Billing and Payment History</a></li>
                <li><a href="/referral_dashboard">Refer & Win</a></li>
                <li><a href="/profile">My Profile</a></li>
                <li><a href="/contact_us">Support</a></li>
              </ul>
            </aside>
      <main className="main-content">
            <section className="data-table">
            <h4>Billing & Payment History</h4>
      <div className="table-responsive">
      {loading ? (
        <p>Loading...</p>
      ) : history.length === 0 ? (
        <p>No payment history found.</p>
      ) : (
    <table className="min-w-full border">
       <thead>
        <tr className="bg-gray-100">
            <th className="px-4 py-2 border">Plan</th>
            <th className="px-4 py-2 border">Duration</th>
            <th className="px-4 py-2 border">Amount ($)</th>
            <th className="px-4 py-2 border">Status</th>
            <th className="px-4 py-2 border">Date</th>
        </tr>
        </thead>
        <tbody>
        {history.map(item => (
            <tr key={item.id}>
            <td className="px-4 py-2 border">
                {item.package_id === 1 ? 'Free Trial' : 
                 item.package_id === 2 ? 'Silver' :
                 item.package_id === 3 ? 'Gold' :
                 item.package_id === 4 ? 'Platinum' :
                 item.package_id}
            </td>
            <td className="px-4 py-2 border">{item.months}</td>
            <td className="px-4 py-2 border">{item.amount}</td>
            <td className="px-4 py-2 border">
                {item.status === '1' ? 'Paid' : 
                 item.status === '2' ? 'Cancelled' :
                 item.status === '3' ? 'Rejected' :
                 item.status === '4' ? 'Refund' :
                 item.status}</td>
            <td className="px-4 py-2 border">
                {new Date(item.payment_date).toLocaleDateString()}
            </td>
            </tr>
        ))}
        </tbody>
        </table>
      )}
      </div>
  </section>
  </main>
  </div>
  </div>  
  );
}

export default Payment_History;
